// extracted by mini-css-extract-plugin
module.exports = {"setPassword":"setPassword__3OvPF","body":"body__BZAOk screenBody__3h2Kk","policy":"policy__1MZFP","form":"form__144Hy"};